import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  active: false,
  msg: '',
  type: 'accept'
});

export function showMsg(state, msg, type) {
  return state.merge({ active: true, msg, type });
}

export function hideMsg(state) {
  return state.merge({ active: false });
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SNACKBAR_SHOW_MSG':
      return showMsg(state, action.msg, action.snackType);

    case 'SNACKBAR_HIDE':
      return hideMsg(state);

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/snackbar.js